// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"7cf296500628302e","615":"30edabf6b81c898c"}[chunkId] + ".css";
};